<template lang="pug">
  el-container(id="RoleEdit-container")
    el-dialog(id="RoleEdit-dialogWrapper" :close-on-click-modal="false", :visible.sync="mutableEditDialogVisible", fullscreen=false, :title="$t(roleData.id ? 'Edit role' : 'Add role')", :before-close="beforeCloseHandler", append-to-body)
      el-form(
        id="RoleEdit-form",
        :model="roleData",
        :rules="rules",
        ref="roleForm",
        label-width="180px",
        status-icon=true,
        :size="uxParam('formSize')",
        v-loading="loading",
      )
        el-form-item(:label="$t('Role name')", prop="name")
          el-input(id="RoleEdit-formNameInput" v-model="roleData.name")
        el-form-item(:label="$t('Privileges')", prop="PrivilegeIds")
          el-select.el-select-width-100(id="RoleEdit-formPrivilagesSelect" v-model='roleData.PrivilegeIds', multiple)
            el-option(
              v-for="item in privilegeList",
              :key="item.id",
              :label="item.entity + '/' + item.action + ':' + item.method",
              :value="item.id",
              :id="'RoleEdit-formPrivilagesOption' + item.id"
            )
      .dialog-footer(slot="footer")
        el-button(
          id="RoleEdit-formSaveButton",
          type="primary",
          @click="submitForm('roleForm')"
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')",
          :disabled="loading"
        ) {{$t('Save')}}
        el-button(
          id="RoleEdit-formCancelButton",
          @click='mutableEditDialogVisible = false'
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')"
        ) {{$t('Cancel')}}
</template>

<script>

export default {
  props: {
    'roleId': {
      required: true
    },
    'editDialogVisible': {
      required: true
    }
  },
  data () {
    return {
      loading: true,
      roleData: {
        id: 0,
        name: '',
        Privileges: [],
        PrivilegeIds: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('Please enter role name'), trigger: 'blur' }
        ]
      },
      privilegeList: {}
    }
  },
  watch: {
    roleId: async function (newVal, oldVal) {
      this.loading = true
      this.roleData = {
        id: 0,
        name: '',
        Privileges: [],
        PrivilegeIds: []
      }

      this.privilegeList = await this.$store.dispatch('Privilege/getPrivileges')

      this.$nextTick(function () {
        this.$refs['roleForm'].resetFields()
      })

      if (this.roleId !== null && this.roleId !== 0) {
        let roleData = await this.$store.dispatch('Role/getRoleData', {
          data: {
            roleId: this.roleId
          }
        })
        this.roleData = JSON.parse(JSON.stringify(roleData))
      }

      this.loading = false
    }
  },
  methods: {
    async submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(this.roleId === 0 ? 'Role/createRoleData' : 'Role/updateRoleData', {
            data: JSON.parse(JSON.stringify(this.roleData))
          })
            .then(response => {
              this.mutableEditDialogVisible = false
              this.loading = false
            })
            .catch(error => {
              console.log(error.response.status)
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    beforeCloseHandler: function (done) {
      done()
    }
  },
  computed: {
    mutableEditDialogVisible: {
      get: function () {
        return this.editDialogVisible
      },
      set: function (value) {
        this.$emit('closeEditDialog', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Role/RoleEdit.vue